module.exports = __webpack_public_path__ + "assets/-_7.f223267f.svg";